import { render, staticRenderFns } from "./kehuanlic.vue?vue&type=template&id=4a8f768e&scoped=true&"
import script from "./kehuanlic.vue?vue&type=script&lang=js&"
export * from "./kehuanlic.vue?vue&type=script&lang=js&"
import style0 from "./kehuanlic.vue?vue&type=style&index=0&id=4a8f768e&lang=less&scoped=true&"
import style1 from "./kehuanlic.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8f768e",
  null
  
)

export default component.exports